<app-print-layout-matDialog (imprimir)="onImprimir()" (fechar)="onFechar()" [retrato]="false" titulo="Imprimir Plano de Ação">

    <div class="card-body">

        <div *ngIf="minuta" class="watermark">MINUTA</div>

        <div>
            <div class="row mb-1">
                <div class="col-md-12" style="font-weight: bold; font-size: 16pt; text-align: center;">
                    Plano de Ação - OSA Nº {{model?.osaExecucao?.osa?.numero}}
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-md-12" style="padding-top: 15px;">
                    <table class="table" style="border: 1px solid #ccc; border-collapse: collapse; width: auto;">
                        <thead>
                            <tr>
                                <td [attr.colspan]="1" style="text-align: left; vertical-align: middle; border: 1px solid #ccc; background-color: #f2f2f2;">
                                    <strong> Unidade Auditada </strong>
                                </td>
                                <td [attr.colspan]="5" style="text-align: left; vertical-align: middle; border: 1px solid #ccc; background-color: #f2f2f2;">
                                    <strong> {{model.unidadeGestora?.codigoUg}} - {{model.unidadeGestora?.nome}} / {{model.unidadeGestora?.sigla}} </strong>
                                </td>
                                <td [attr.colspan]="1" style="text-align: left; vertical-align: middle; border: 1px solid #ccc; background-color: #f2f2f2;">
                                    <strong> Data de Elaboração </strong>
                                </td>
                                <td [attr.colspan]="1" style="text-align: left; vertical-align: middle; border: 1px solid #ccc; background-color: #f2f2f2;">
                                    <strong>{{ model?.dataFinalizacao | date:'dd/MM/yyyy' }} </strong>
                                </td>
                            </tr>
                            <tr>
                                <td [attr.colspan]="1" style="text-align: left; vertical-align: middle; border: 1px solid #ccc; background-color: #f2f2f2;">
                                    <strong> Objeto Auditado </strong>
                                </td>
                                <td [attr.colspan]="7" style="text-align: left; vertical-align: middle; border: 1px solid #ccc; background-color: #f2f2f2;">
                                    <strong> {{model?.osaExecucao?.osa?.planejamento?.opa?.objeto}} </strong>
                                </td>
                            </tr>

                            <tr>
                                <th style="width: 80px; text-align: center; vertical-align: middle; border: 1px solid #ccc; background-color: #f2f2f2;">
                                    Nº da Ação
                                </th>
                                <th style="width: 200px; text-align: center; vertical-align: middle; border: 1px solid #ccc; background-color: #f2f2f2;">
                                    Título  <br> da Ação
                                </th>
                                <th style="width: 200px; text-align: center; vertical-align: middle; border: 1px solid #ccc; background-color: #f2f2f2;">
                                    Recomendação <br> Vinculada
                                </th>
                                <th style="width: 200px; text-align: center; vertical-align: middle; border: 1px solid #ccc; background-color: #f2f2f2;">
                                    Constatação <br> Vinculada
                                </th>
                                <th style="width: 130px; text-align: center; vertical-align: middle; border: 1px solid #ccc; background-color: #f2f2f2;">
                                    Responsável
                                </th>
                                <th style="width: 130px; text-align: center; vertical-align: middle; border: 1px solid #ccc; background-color: #f2f2f2;">
                                    Data <br> Limite
                                </th>
                                <th style="width: 130px; text-align: center; vertical-align: middle; border: 1px solid #ccc; background-color: #f2f2f2;">
                                    Data <br> Realizada
                                </th>
                                <th style="width: 130px; text-align: center; vertical-align: middle; border: 1px solid #ccc; background-color: #f2f2f2;">
                                    Status <br> Ação
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let item of model.acoes">
                                <tr>
                                    <td [attr.rowspan]="getRowSpanAcao(item)"
                                        style="width: 60px; border: 1px solid #ccc; vertical-align: middle;">
                                        {{ item.identificador }}
                                    </td>

                                    <td [attr.rowspan]="getRowSpanAcao(item)"
                                        style="width: 60px; border: 1px solid #ccc; vertical-align: middle;"
                                        [innerHTML]="item.titulo">
                                    </td>

                                    <!-- PRIMEIRA RECOMENDAÇAO -->
                                    <ng-container
                                        *ngIf="item.recomendacoes && item.recomendacoes.length > 0; else semRecomendacoes">
                                        <td [attr.rowspan]="getRowSpanRecomendacao(item.recomendacoes[0])" style="width: 130px; border: 1px solid #ccc;">
                                            <strong>{{ item.recomendacoes[0].recomendacao.titulo }} - </strong> {{
                                            item.recomendacoes[0].recomendacao.descricao }}
                                        </td>
                                    </ng-container>

                                    <!-- PRIMEIRA CONSTATAÇÃO -->
                                    <ng-container
                                        *ngIf="item.recomendacoes[0].recomendacao.itensVinculados && item.recomendacoes[0].recomendacao.itensVinculados.length > 0; else semConstatacoes">
                                        <td class="break-text" style="width: 130px; border: 1px solid #ccc;">
                                            <strong> 
                                            {{
                                            item.recomendacoes[0].recomendacao.itensVinculados[0].osaExecucaoMatrizConstatacaoItem.identificador
                                            }} - </strong> {{
                                            item.recomendacoes[0].recomendacao.itensVinculados[0].osaExecucaoMatrizConstatacaoItem.descricaoConstatacao
                                            }}
                                        </td>
                                    </ng-container>

                                    <td [attr.rowspan]="getRowSpanAcao(item)"
                                        style="width: 130px; text-align: center; vertical-align: middle; border: 1px solid #ccc;" 
                                        [innerHTML]="item.responsavelNome">
                                    </td>

                                    <td [attr.rowspan]="getRowSpanAcao(item)"
                                        style="width: 130px; text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                        {{item.prazo | date:'dd/MM/yyyy'}}
                                    </td>

                                    <td [attr.rowspan]="getRowSpanAcao(item)"
                                        style="width: 130px; text-align: center; vertical-align: middle; border: 1px solid #ccc;">
                                        {{ item.dataRealizacao && (item.dataRealizacao | date:'dd/MM/yyyy') || '' }}
                                    </td>

                                    <td [attr.rowspan]="getRowSpanAcao(item)"
                                        style="width: 130px; text-align: center; vertical-align: middle; border: 1px solid #ccc;">

                                        <span class="badge text-xs"
                                            [ngClass]="getStatusClass(item.status.codigo)" 
                                            style="display: inline-block; min-width: 100px; text-align: center;" >
                                            {{ item.status.descricao }}
                                        </span>
                                    </td>

                                    <!-- CASO NÃO TENHA RECOMENDAÇÃO -->
                                    <ng-template #semRecomendacoes>
                                        <td style="border: 1px solid #ccc;"></td>
                                    </ng-template>

                                    <!-- CASO NÃO TENHA CONSTATACAP -->
                                    <ng-template #semConstatacoes>
                                        <td style="border: 1px solid #ccc;"></td>
                                    </ng-template>

                                </tr>

                                <!-- DEMAIS CONSTATAÇÕES DA PRIMEIRA RECOMENDAÇÃO -->
                                <ng-container
                                    *ngFor="let c of item.recomendacoes[0]?.recomendacao.itensVinculados?.slice(1)">
                                    <tr>
                                        <td class="break-text" style="border:1px solid #ccc;">
                                            <strong>{{ c.osaExecucaoMatrizConstatacaoItem.identificador }} - </strong> {{
                                            c.osaExecucaoMatrizConstatacaoItem.descricaoConstatacao }}
                                        </td>
                                    </tr>
                                </ng-container>


                                <!-- DEMAIS RECOMENDAÇÕES -->
                                <ng-container *ngFor="let r of item.recomendacoes.slice(1)">

                                    <tr>
                                        <td [attr.rowspan]="getRowSpanRecomendacao(r)" style="border:1px solid #ccc;">
                                            <strong>{{ r.recomendacao.titulo }} - </strong>
                                            {{ r.recomendacao.descricao }}
                                        </td>

                                        <!-- PRIMEIRA CONSTATAÇÃO DA RECOMENDAÇÃO -->
                                        <td class="break-text" style="border:1px solid #ccc;">
                                            <strong>{{
                                            r.recomendacao.itensVinculados[0].osaExecucaoMatrizConstatacaoItem.identificador
                                            }} - </strong> {{
                                            r.recomendacao.itensVinculados[0].osaExecucaoMatrizConstatacaoItem.descricaoConstatacao
                                            }}
                                        </td>
                                    </tr>

                                    <!-- DEMAIS CONSTATAÇÕES -->
                                    <ng-container *ngFor="let c of r.recomendacao.itensVinculados?.slice(1)">
                                        <tr>
                                            <td class="break-text" style="border:1px solid #ccc;">
                                                <strong>{{ c.osaExecucaoMatrizConstatacaoItem.identificador }} - </strong> {{
                                                c.osaExecucaoMatrizConstatacaoItem.descricaoConstatacao }}
                                            </td>
                                        </tr>
                                    </ng-container>

                                </ng-container>

                            </ng-container>
                        </tbody>
                    </table>
                </div>
                <div class="col-md-12">
                    <div>Data da Impressão: <strong> {{ dataHoje | date:'dd/MM/yyyy' }} </strong> </div>
                    <div style="height: 5px;"></div>

                    <div><strong>Elaboração Técnica:</strong> </div>
                    <div>Nome: {{ model?.responsavelNomeFinalizacao }} </div>
                    <div>Cargo do Servidor: {{ model?.responsavelCargoFinalizacao }} </div>

                    <div style="height: 5px;"></div>
                    <div><strong>Aprovação:</strong> </div>
                    <div>Nome: {{ model?.responsavelNomeEnvioAvaliacao }} </div>
                    <div>Cargo do Servidor: {{ model?.responsavelCargoEnvioAvaliacao }} </div>

                </div>
            </div>
        </div>
    </div>
</app-print-layout-matDialog>